import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import { AssignPlaylistButton, PlaylistAssignmentsPortalProgress, useFilteredPlaylistAssignmentsPortals } from '..';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled, { css, mediaQuery, theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import { TABLE_PAGINATOR_SIZE } from '../../table';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import { AvatarViewer } from '../../avatar';
import formatName from 'I18n/utils/formatName';
import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import { UserLink, UserLinkWithExternalIcon } from '../../users';
import UIFlex from 'UIComponents/layout/UIFlex';
import MobileNestedMenu from '../../../components/Modals/FullScreenModal/MobileNestedMenu';
import UIIconButton from 'UIComponents/button/UIIconButton';
import I18n from 'I18n';
import { MenuRow } from '../../cardMenu/components/MobileCardMenu';
import { Fragment, useState } from 'react';

// a bit hacky but it is the only way to customise the sections
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledRow = styled(UIExpandableSection).attrs({
  use: 'enclosed'
}).withConfig({
  displayName: "PlaylistAssignmentsPortalsList__StyledRow",
  componentId: "sc-1eqk5ia-0"
})(["& >:first-child{background-color:", ";}div[role='button'][aria-expanded]{> h2{width:100%;padding-right:", ";", ";}> span{", ";}}"], theme.colors.OLAF, ({
  $hasActions
}) => $hasActions ? '0' : '4px', ({
  $hasExpandableContent
}) => $hasExpandableContent ? '' : 'padding-left: 18px', ({
  $hasExpandableContent
}) => $hasExpandableContent ? '' : 'display: none');
const StyledMenuIcon = styled(UIIcon).withConfig({
  displayName: "PlaylistAssignmentsPortalsList__StyledMenuIcon",
  componentId: "sc-1eqk5ia-1"
})(["font-size:20px;width:26px;height:26px;transform:translateY(16px);"]);
const PortalContentRow = styled(UIFlex).attrs({
  gap: 18,
  align: 'center'
}).withConfig({
  displayName: "PlaylistAssignmentsPortalsList__PortalContentRow",
  componentId: "sc-1eqk5ia-2"
})([".portal-content-action{visibility:hidden;color:", ";transition:ease 0.3s color;&:hover{color:", ";}", "}&:hover{.portal-content-action{visibility:visible;}}"], theme.colors.EERIE, theme.colors.PANTERA, mediaQuery('mobile', css(["visibility:visible;"])));
const PlaylistAssignmentsPortalOptions = ({
  portal,
  onClick
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const [menuOpen, setMenuOpen] = useState(true);
  const Component = isMobile ? MobileNestedMenu : UIList;
  const ButtonContainerComponent = isMobile ? MenuRow : Fragment;
  return /*#__PURE__*/_jsx(Component, {
    indented: false,
    open: menuOpen,
    setIsOpen: setMenuOpen,
    useBackText: true,
    useSidePanel: true,
    children: /*#__PURE__*/_jsx(ButtonContainerComponent, {
      children: /*#__PURE__*/_jsxs(AssignPlaylistButton, {
        onClick: () => {
          if (onClick) onClick(portal);
        },
        playlistId: portal.playlistId,
        portalId: portal.portal.id,
        style: {
          width: '100%'
        },
        use: "unstyled",
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "add"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          className: "m-left-2",
          message: "learningCenter.common.assign"
        })]
      })
    })
  });
};
const PlaylistAssignmentsPortalContent = ({
  portal: {
    assignees,
    portal: {
      id: portalId
    }
  }
}) => {
  return /*#__PURE__*/_jsx(UIList, {
    childClassName: "m-bottom-4",
    lastChildClassName: "m-bottom-0",
    children: assignees.map(({
      userId,
      avatarHash,
      firstName,
      lastName
    }) => {
      const displayName = formatName({
        firstName,
        lastName
      });
      return /*#__PURE__*/_jsxs(PortalContentRow, {
        children: [/*#__PURE__*/_jsx(UserLink, {
          portalId: portalId,
          style: {
            display: 'flex'
          },
          userId: userId,
          children: /*#__PURE__*/_jsx(AvatarViewer, {
            avatarHash: avatarHash,
            displayName: displayName,
            size: "md",
            type: "contact"
          })
        }), /*#__PURE__*/_jsxs(UIFlex, {
          direction: "column",
          gap: 0,
          children: [/*#__PURE__*/_jsx(UserLinkWithExternalIcon, {
            external: true,
            portalId: portalId,
            userId: userId,
            children: displayName
          }), /*#__PURE__*/_jsx("span", {
            style: {
              color: theme.colors.PANTERA
            },
            children: userId
          })]
        }), /*#__PURE__*/_jsx(UIIconButton, {
          className: "portal-content-action m-right-2",
          placement: "right",
          tooltip: I18n.text('learningCenter.common.unassign'),
          use: "unstyled",
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "delete"
          })
        })]
      }, userId);
    })
  });
};
const PlaylistAssignmentsPortalRow = ({
  portal,
  renderRow = () => /*#__PURE__*/_jsx(PlaylistAssignmentsPortalProgress, {
    portal: portal,
    showAssigneesCount: true
  }),
  renderOptions = () => /*#__PURE__*/_jsx(PlaylistAssignmentsPortalOptions, {
    portal: portal
  }),
  renderRowContents = () => /*#__PURE__*/_jsx(PlaylistAssignmentsPortalContent, {
    portal: portal
  }),
  onRowOpenChange
}) => {
  const handleOpenChange = e => {
    const isOpen = e.target.value;
    if (onRowOpenChange) onRowOpenChange({
      isOpen,
      portal
    });
  };
  return /*#__PURE__*/_jsx(StyledRow, {
    $hasActions: !!renderOptions,
    $hasExpandableContent: !!renderRowContents,
    actions: renderOptions && /*#__PURE__*/_jsx(UIDropdown, {
      buttonUse: "transparent",
      caretRenderer: /*#__PURE__*/_jsx(StyledMenuIcon, {
        name: "verticalMenu"
      }),
      iconName: "",
      children: /*#__PURE__*/_jsx(UIList, {
        children: renderOptions(portal)
      })
    }),
    "data-test-id": `row_${portal.portal.id}`,
    onOpenChange: handleOpenChange,
    titleText: renderRow(portal),
    children: renderRowContents && renderRowContents(portal)
  });
};
const PlaylistAssignmentsPortalsList = ({
  playlistId,
  renderRow,
  renderRowContents,
  renderOptions,
  onRowOpenChange
}) => {
  const [page, setPage] = useState(1);
  const {
    playlistAssignmentsPortals,
    pageCount
  } = useFilteredPlaylistAssignmentsPortals({
    playlistId,
    page
  });
  if (!playlistAssignmentsPortals) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("section", {
      className: "playlist-assignments-list",
      children: playlistAssignmentsPortals.map(portal => /*#__PURE__*/_jsx(PlaylistAssignmentsPortalRow, {
        onRowOpenChange: onRowOpenChange,
        portal: portal,
        renderOptions: renderOptions,
        renderRow: renderRow,
        renderRowContents: renderRowContents
      }, `${playlistId}_${portal.portal.id}`))
    }), pageCount > 1 && /*#__PURE__*/_jsx(UIPaginator, {
      className: "m-top-3",
      maxVisiblePageButtons: TABLE_PAGINATOR_SIZE,
      onPageChange: ({
        target: {
          value
        }
      }) => setPage(value),
      page: page,
      pageCount: pageCount
    })]
  });
};
export default PlaylistAssignmentsPortalsList;